import { Injectable } from '@angular/core';
import { CurrentApiService, IElement } from 'dbweb-core';
export enum DumpType {
	institution = 'institution',
	data = 'data'
}
interface InstitutionModel {
	Name: string;
	Tables: string;
}
interface DumpResult {
	TaskInfoURL: string;
	TaskInfoSign: string;
	BrowseTaskElement: IElement;
}
@Injectable()
export class DumpInstitutionService {
	models: InstitutionModel[];
	dumpType = DumpType.institution;
	constructor(private api: CurrentApiService) {}
	init() {
		this.getModels().subscribe(v => {
			this.models = v;
		});
	}
	getModels() {
		return this.api.get<InstitutionModel[]>('get-models');
	}
	dump() {
		return this.api.post<DumpResult>('dump', this.dumpType);
	}
}
